/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_TitleInputs */

const en_mk_sec_title = /** @type {(inputs: Mk_Sec_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure by default, not an add-on`)
};

const id_mk_sec_title = /** @type {(inputs: Mk_Sec_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aman secara default, bukan opsi tambahan`)
};

/**
* | output |
* | --- |
* | "Secure by default, not an add-on" |
*
* @param {Mk_Sec_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_title = /** @type {((inputs?: Mk_Sec_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_title(inputs)
	return en_mk_sec_title(inputs)
});